export default "__VITE_ASSET__CTFeSI3f__"